import { webApi } from '@lib/api'

export const listCredential = (query = {}) => webApi({ auth: true }).get('/v1/site/credential', query)

export const createCredential = (data = {}) => webApi({ auth: true }).post('/v1/site/credential', data)
export const deleteCredential = credentialId => webApi({ auth: true }).delete(`/v1/site/credential/${credentialId}`)
